import { useState, useEffect } from 'react';
import base64 from "base-64";
import ENV from "../env";

const SummaryHomeApi = (url, param) => { 
    const [summaryResponse, setSummaryResponse] = useState(null);
    const [summaryError, setSummaryError] = useState(null);
    const [isSummaryLoading, setIsSummaryLoading] = useState(false);
    const [isSummaryRefresh, setSummaryRefresh] = useState(false);

    const doFetchSummary = () => {
        setSummaryRefresh(!isSummaryRefresh)
    }

    const fetchData = async (url, options) => {
        setIsSummaryLoading(true);

        try {
            const updateUrl = `${url}`;
            const res = await fetch(updateUrl, options);
            const json = await res.json();
            setSummaryResponse(json);
            setIsSummaryLoading(false);
        } catch (error) {
            setSummaryError(error);
        }
    };


    useEffect(() => {

        const createToken = () => {
            Promise.all([
                localStorage.getItem('userId'),
                localStorage.getItem('sToken')
            ]).then(async (res) => {
                let userId = JSON.parse(res[0]);
                let sToken = JSON.parse(res[1]);
                let header = base64.encode(`${userId}:${sToken}`);
                let security = `Basic ${header}`;

                const options = {
                    headers: {
                        'Accept': 'application/json',
                        'Security': security,
                        'Content-Type': 'application/json',
                    }
                };
                let newUrl = url;

                if(param){

                    newUrl = `${ENV.LOCUSB_API}/${newUrl}/${userId}/${param}`;
                }
                fetchData(newUrl, options);

            }).catch(err => {
                console.log("API call error", err)
            })
        }
        if (url) {
            createToken();
        }
    }, [isSummaryRefresh]);

    return { summaryResponse, summaryError, isSummaryLoading, doFetchSummary };
};

export default SummaryHomeApi;